import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonComponent } from '@shared/components/button/button.component';
import { CartService } from '@b2b/features/cart/core/cart.service';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'cart-coupon',
  imports: [CommonModule, FormsModule, ButtonComponent, TranslateModule],
  templateUrl: './cart-coupon.component.html',
  styleUrl: './cart-coupon.component.scss',
})
export class CartCouponComponent implements OnInit, OnDestroy {
  couponCode: string = '';
  errorMessage: string | null = null;
  appliedCouponCode: string | null = null;
  appliedCouponMessage: string | null = null;
  isLoading: boolean = false;

  private subscription: Subscription | null = null;
  private cartSubscription: Subscription | null = null;

  constructor(private cartService: CartService) {}

  ngOnInit(): void {
    this.cartSubscription = this.cartService.takeCart().subscribe(cart => {
      this.appliedCouponCode = cart.couponCode ?? null;
      this.appliedCouponMessage = cart.couponMessage ?? null;
    });
  }

  applyCoupon(): void {
    const code = this.couponCode.trim();
    if (!code || this.isLoading) return;

    this.isLoading = true;
    this.errorMessage = null;

    this.subscription = this.cartService.applyCoupon(code).subscribe({
      next: result => {
        this.isLoading = false;

        if (result.hasError) {
          this.errorMessage = 'cart.coupon.notFound';
        } else {
          this.appliedCouponCode = code;
          this.appliedCouponMessage = result.data?.couponMessage ?? null;
          this.couponCode = '';
          this.errorMessage = null;
        }
      },
      error: () => {
        this.isLoading = false;
        this.errorMessage = 'cart.coupon.notFound';
      },
    });
  }

  removeCoupon(): void {
    if (this.isLoading) return;

    this.isLoading = true;
    this.errorMessage = null;

    this.subscription = this.cartService.removeCoupon().subscribe({
      next: result => {
        this.isLoading = false;

        if (result.hasError) {
          this.errorMessage = 'cart.coupon.removeError';
        } else {
          this.appliedCouponCode = null;
          this.appliedCouponMessage = null;
          this.couponCode = '';
          this.errorMessage = null;
        }
      },
      error: () => {
        this.isLoading = false;
        this.errorMessage = 'cart.coupon.removeError';
      },
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.cartSubscription?.unsubscribe();
  }
}
